<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="show" :data="model" :title="$t('Tax Rate')" @show="onShow" size="sm"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <input-widget :label="false" :model="model" attribute="tax_rate" type="number" autofocus/>

    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import TaxRateForm from "@/modules/customer/models/TaxRateForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('reservations');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "TaxRateModal",
    components: {InputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        model: new TaxRateForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['hideTaxRateModal', 'updateLotTaxRate']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t("Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?"))
        if (!success) {
          return;
        }

        this.loading = true;
        let response = await this.updateLotTaxRate({
          lotUuid: this.model.lot_uuid,
          data: {tax_rate: this.model.tax_rate}
        });
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideTaxRateModal();
          this.$toast('success', this.$t('Tax Rate was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new TaxRateForm();
        this.hideTaxRateModal(false);
      },
    },
    watch: {
      editObject() {
        this.model = new TaxRateForm(this.editObject);
      }
    },
    computed: {
      ...mapState({
        show: state => state.view.termsData.taxRateModal.show,
        editObject: state => state.view.termsData.taxRateModal.object,
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>

